import flow from 'lodash/flow';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';

import { ITEM_TYPE_NODE_CONTENT } from '../../constants/itemTypes';

class FormEditorDndNodeContentWrapper extends Component {
    static propTypes = {
        // Drag and drop injected props.
        connectDragSource: PropTypes.func.isRequired,
        connectDragPreview: PropTypes.func.isRequired,
        connectDropTarget: PropTypes.func.isRequired,

        children: PropTypes.func.isRequired,
    };

    render() {
        return (
            // Connect drag preview here to show as preview a screenshot of the dragged node.
            this.props.connectDragPreview(
                // Connect drop target here so that each node works as a drop target.
                this.props.connectDropTarget(<div>{this.props.children(this.props.connectDragSource)}</div>),
            )
        );
    }
}

const dragSpec = {
    canDrag(props, monitor, component) {
        return true;
    },
    beginDrag(props, monitor, component) {
        if (component.nodeContent && typeof component.nodeContent.unsetActive === 'function') {
            component.nodeContent.unsetActive();
        }
        props.beginDragFormNode(props.formNode.id);
        return props.formNode;
    },
    endDrag(props, monitor, component) {
        props.endDragFormNode();
    },
};

const dragCollect = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
});

const dropSpec = (() => {
    // Make sure we're hovering over something different
    let hoverMemo;
    return {
        canDrop(props, monitor, component) {
            return true;
        },
        hover(props, monitor, component) {
            const { formNode, hoverDropFormNode } = props;
            const { y } = monitor.getClientOffset();
            const hoverKey = y;
            if (hoverKey !== hoverMemo) {
                hoverMemo = hoverKey;

                // Perform DOM measurement to figure out the drop location
                // eslint-disable-next-line react/no-find-dom-node
                const el = findDOMNode(component);
                const { top, bottom } = el.getBoundingClientRect();
                const yPosition = (y - top) / (bottom - top);
                hoverDropFormNode(formNode.id, yPosition);
            }
            return formNode;
        },
        drop(props, monitor, component) {
            // Reset the hover
            hoverMemo = null;
            return props.formNode;
        },
    };
})();

const dropCollect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
});

const decoratedComponent = flow(
    DragSource(ITEM_TYPE_NODE_CONTENT, dragSpec, dragCollect),
    DropTarget(ITEM_TYPE_NODE_CONTENT, dropSpec, dropCollect),
)(FormEditorDndNodeContentWrapper);

// Prop types of the react-dnd decorated component.
decoratedComponent.propTypes = {
    formNode: PropTypes.object.isRequired,
    beginDragFormNode: PropTypes.func.isRequired,
    endDragFormNode: PropTypes.func.isRequired,
    hoverDropFormNode: PropTypes.func.isRequired,
};

export default decoratedComponent;
